const productSeo = {
    1: {
      title: "Stretching Clamps | Pneumatic Screen Printing Clamp – Cheran",
      description:
        "Cheran’s Stretching Clamp for screen printing offers precision and durability. Leading screen stretching clamp manufacturer in India.",
      keywords:
        "Stretching Clamps, Pneumatic Stretching Clamp, Cheran’s stretching clamp, stretching clamp for screen printing, screen stretching clamp manufacturer India, Stretching Clamps, Pneumatic Stretching Clamp"
    },
  2: {
    title: "X-WEL Exposing Machine for Screen Printing | Cheran Machines",
    description:
      "X-WEL Exposing Machine designed for textile and screen printing industries. Ensures uniform exposure, vacuum accuracy, and long service life.",
    keywords:
      "x-wel exposing machine, screen exposing machine, textile exposing machine, Cheran Machines"
  },
  3: {
    title: "Cheran Screen Dryer | Industrial Textile Printing Dryer",
    description:
      "Cheran Screen Dryer offers fast, efficient drying for textile and garment printing. Leading industrial screen dryer manufacturer in India.",
    keywords:
      "screen dryer machine, Cheran Screen Dryer, textile printing dryer,"
  },
  4: {
    title: "Cheran Screen Washer | Leading Screen Washer Manufacturer",
    description:
      "Cheran’s Screen Washer delivers efficient and reliable cleaning for textile printing. Top screen washer manufacturer in India.",
    keywords:
      "Screen Washer, Cheran Screen Washer, Cheran's Screen Washer screen washer manufacturer India,"
  },
  5: {
    title: "Cheran Washing Booth | Screen Washing Booth for Garments",
    description:
      "Cheran Washing Booth is designed for efficient garment screen washing. Reliable screen washing booth solution for textile printing units.",
    keywords:
      "Washing Booth, Screen Washing Booth, Cheran Washing Booth, garment screen wash booth, Washing Booth, Screen Washing Booth,"
  },
  6: {
    title: "Stirrer Motor Stand Type | Cheran Stirring Motor Stand",
    description:
      "Cheran Stirrer Motor Stand Type offers stable and efficient mixing. Reliable stirring motor with stand for textile printing applications.",
    keywords:
      "stirrer motor stand type, Cheran stirrer motor stand, stirring motor with stand"
  },
  7: {
    title: "Stirrer Motor Hanging Type | Industrial Stirrer – Cheran",
    description:
      "Cheran’s Stirrer Motor Hanging Type delivers powerful industrial mixing. Ideal industrial stirrer motor for textile printing applications.",
    keywords:
      "hanging stirrer motor, Cheran’s Stirrer Motor Hanging Type, industrial stirrer motor hanging, industrial stirrer"
  },
  8: {
    title: "Foot Mounted Stirrer Motor | Industrial Stirrer – Cheran",
    description:
      "Cheran’s foot mounted stirrer motor delivers stable industrial mixing. Reliable industrial stirrer motor with foot mount for printing units.",
    keywords:
      "foot mounted stirrer motor, Cheran’s foot mounted stirrer motor, industrial stirrer motor with foot mount, foot mounted stirrer motor for ink mixing, industrial stirrer motor for textile printing, pigment mixing motor manufacturer"
  },
  9: {
    title: "Manual Printing Machine | Manual Screen Printing – Cheran",
    description:
      "Cheran’s manual printing machine is ideal for garment and textile printing. Trusted manual screen printing machine manufacturer in India.",
    keywords:
      "manual printing machine, Cheran’s manual printing machine, manual screen printing machine, manual screen printing machine for garments, Manual Screen Printing Machine for Textile, garment printing manual press, manual printing machine manufacturer India"
  },
  10: {
    title: "Cheran’s Ceramic Flash Curer | Garment Flash Curing",
    description:
      "Cheran’s Ceramic Flash Curer delivers fast and uniform curing for garment printing. Ideal flash curing and gas curing machine solution.",
    keywords:
      "ceramic flash curer, Cheran’s Ceramic Flash Curer, flash curing machine, garment flash curing machine, Gas Curing Machine."
  },
  11: {
    title: "Micro Registration Screen Printing Machine – Cheran",
    description:
      "Cheran’s Micro Registration Printing Machine ensures precise multi-colour printing. Ideal micro registration screen printing machine for garments.",
    keywords:
      "micro registration printing machine, Cheran's Micro Registration Printing Machine, micro registration screen printing machine, Manual Screen Printing Machine for Textile, Micro Registration Textile Printing Machines"
  },
  12: {
    title: "Cheran’s Electric Flash Curer | IR Curer Machine",
    description:
      "Cheran’s Electric Flash Curer (IR Curer CIR) ensures fast, precise curing for screen printing. Ideal electric flash curer for textile applications.",
    keywords:
      "electric flash curer, Cheran's Electric Flash Curer, IR curer machine, electric flash curer for screen printing, IR flash curing machine for garments, electric flash curer for screen printing, Infrared curing machine manufacturer India "
  },
  13: {
    title: "Cheran’s Electric Dryer Conveyor Curing Machine",
    description:
      "Cheran’s Electric Dryer Conveyor Curing provides fast, efficient textile and garment drying. Reliable electric conveyor curing solution for screen printing.",
    keywords:
      "electric conveyor curing machine, electric dryer conveyor curing, Cheran's Electric Dryer Conveyor Curing, conveyor dryer for garment printing, electric conveyor curing machine, textile curing conveyor dryer"
  },
  14: {
    title: "Cheran’s Diesel Curing Machine | Textile & Garment Dryer",
    description:
      "Cheran’s Diesel Curing Machine offers efficient garment and textile drying. Reliable diesel and gas curing machine manufacturer in India.",
    keywords:
      "diesel curing machine, Cheran’s diesel curing machine, diesel gas dryer, diesel curing machine for garment printing, diesel dryer for textile curing, gas and diesel curing machine manufacturer."
  },
  15: {
    title: "Gas Curing Machine for Garments – Cheran’s Gas Dryer",
    description:
      "Cheran’s Gas Dryer provides efficient garment and textile curing. Reliable gas curing machine for the textile printing industry in India.",
    keywords:
      "Cheran’s gas dryer, gas curing machine, gas dryer for garment printing, gas curing machine for textile industry"
  },
  16: {
    title: "Cheran’s Automatic Rainbow Rover | Garment Printing Machine",
    description:
      "Cheran’s Automatic Rainbow Rover is a multi-color automatic screen printing machine for garments. Advanced automatic garment printing press in India.",
    keywords:
      "Cheran’s Automatic Rainbow Rover, Automatic Rainbow Rover, automatic screen printing machine for garments, multi-colour automatic printing machine, automatic garment printing press India."
  },
  17: {
    title: "Digital Heat Transfer Fusing Machine for Garments | Cheran’s",
    description:
      "Cheran’s Digital Heat Transfer Fusing Machine is ideal for labels and garment prints. Advanced digital fusing and heat transfer press solution.",
    keywords:
      "digital heat transfer fusing machine, Cheran’s digital heat transfer machine, digital fusing machine, digital fusing machine for labels and prints, garment heat transfer press."
  },
  18: {
    title: "Embossing Machine for Textile Printing | Cheran’s",
    description:
      "Cheran’s Embossing Machine (CFE 1620) delivers precise embossing for garments. Reliable embossing solution for textile and apparel units.",
    keywords:
      "Cheran’s embossing machine, embossing machine, embossing machine for garments, fabric embossing machine India,  garment embossing press manufacturer, Digital Press, Fabric Embossing Machine"
  },
  19: {
    title: "Sleek Digital Twins Heat Transfer Fusing Machine | Cheran’s",
    description:
      "Cheran’s Sleek Digital Twins Heat Transfer Fusing Machine features twin tray design for high productivity and precision garment fusing.",
    keywords:
      "digital heat transfer fusing machine, Sleek Digital Twins fusing machine, Heat Transfer Fusing Machine, twin tray heat transfer press, dual heat transfer fusing machine, high productivity heat transfer machine, Heat Fusing Machine, Digital Twins Fusing Machine. "
  },
  20: {
    title: "Cheran’s Dual Heat Tray | Heat Transfer Fusing Machine",
    description:
      "Cheran’s Dual Heat Tray is a dual tray heat transfer machine ideal for garment labels and prints. High-efficiency double tray fusing press.",
    keywords:
      "dual heat tray machine, Cheran’s dual heat tray, heat transfer tray press, dual tray heat transfer machine, double tray fusing press, garment label transfer machine, dual tray heat transfer machine."
  },
  21: {
    title: "Manual Screen Printing & Label Transfer | Cheran’s Cute",
    description:
      "Cheran’s Cute manual screen printing machine is ideal for garment label transfer. Compact screen printing machine for garment industry use.",
    keywords:
      "manual screen printing machine, Garment Industry Label Transfer Press, Cheran’s manual screen printing machine, label transfer press for garment industry, compact screen printing machine for garments, small screen printing machine manufacturer."
  },
  22: {
    title: "Manual Screen Printing & Label Transfer | Cheran’s Crystel",
    description:
      "Cheran’s Crystel (CFC 0606) is a compact manual screen printing machine for garment labels. Ideal label transfer press for small units.",
    keywords:
      "Cheran's Crystel(CFC 0606), manual screen printing machine, Garment Industry Label Transfer Press, compact screen printing machine for garments, label transfer press for garment industry, small screen printing machine manufacturer"
  },
  23: {
    title: "Manual Screen Printing & Label Transfer | Cheran’s Cute Square",
    description:
      "Cheran’s Cute Square (CFS 0606) is a compact screen printing machine for garment label transfer. Ideal manual press for small garment units.",
    keywords:
      "Cute Square CFS 0606 screen printing machine, screen printing machine, Garment Industry Label Transfer Press, compact screen printing machine for garments, label transfer press for garment industry, small screen printing machine manufacturer."
  },
  24: {
    title: "Cheran’s Jumbo Sublimation Transfer Machine | Double Tray",
    description:
      "Cheran’s Jumbo Sublimation Transfer Machine with double tray offers high-efficiency heat pressing. Ideal for large-format sublimation printing in India.",
    keywords:
      "Jumbo Sublimation Transfer Machine, double tray sublimation machine, sublimation heat press machine, Cheran's Jumbo Sublimation Transfer Machine, large format sublimation press India"
  },
  25: {
    title: "Cheran’s Swift Roll To Roll Sublimation Transfer Machine",
    description:
      "Cheran’s Swift Roll To Roll Sublimation Transfer Machine offers continuous sublimation heat press for fabric printing. Ideal for high-volume production.",
    keywords:
      "roll to roll sublimation transfer machine, Cheran's Swift Roll To Roll Sublimation Transfer Machine, continuous sublimation heat press, fabric sublimation printing machine, continuous sublimation heat press, Roll Sublimation Transfer Machine,"
  },
  26: {
    title: "Cheran’s Hydro Pneumatic Press | Industrial Heat Press",
    description:
      "Cheran’s Hydro Pneumatic Press delivers precise pressing for garments. Reliable pneumatic heat press from leading industrial pressing machine manufacturer.",
    keywords:
      "Hydro Pneumatic Press, Cheran's Hydro Pneumatic Press, industrial pressing machine manufacturer, hydro pneumatic press for garment industry, pneumatic heat press machine."
  },
  27: {
    title: "3 Station Auto Fusing Machine – Cheran’s T-Rex",
    description:
      "Cheran’s T-Rex 3 Station Auto Fusing Machine provides high-speed, multi-station garment fusing. Ideal for large-scale production in India.",
    keywords:
      "T-Rex 3 Station Auto Fusing Machine, 3 station fusing machine, Cheran's T-Rex 3 Station Auto Fusing Machine, automatic fusing machine for garments, multi station garment fusing machine, high production fusing press India."
  },
  28: {
    title: "Automatic Fusing Machine for Garments | Cheran’s Falcon 6",
    description:
      "Cheran’s Falcon 6 Station Auto Fusing Machine delivers high-speed multi-station garment fusing. Ideal automatic fusing press for large-scale production.",
    keywords:
      "Falcon 6 Station Auto Fusing Machine, Cheran's Falcon 6 Station Auto Fusing Machine, multi station garment fusing machine, automatic fusing machine for garments, multi station garment fusing machine, high production fusing press India"
  },
  29: {
    title: "Automatic Fusing Machine for Garments | Cheran’s Crown 6",
    description:
      "Cheran’s Crown 6 Station Auto Fusing Machine offers multi-station high-production garment fusing. Ideal automatic fusing press for textile industries.",
    keywords:
      "Crown 6 Station Auto Fusing Machine, Cheran's Crown 6 Station Auto Fusing Machine, automatic fusing machine for garments, multi station garment fusing machine, high production fusing press India"
  },
  30: {
    title: "Heat & Cool Fusing Machine for Garments | Cheran’s",
    description:
      "Cheran’s H&C Heat & Cool Fusing Machine provides wrinkle-free garment fusing. Advanced heat & cool fusing press for high-efficiency production.",
    keywords:
      "heat & cool fusing machine, Cheran's H&C Heat & Cool Fusing, heat and cool fusing machine, wrinkle free garment fusing machine, advanced fusing press manufacturer"
  },
  31: {
    title: "Auto Screen Printing Machine | Cheran’s Single Head",
    description:
      "Cheran’s Single Head Auto Print is a high-efficiency automatic garment printing press. Ideal single head auto printing machine for screen printing in India.",
    keywords:
      "Cheran's Single Head Auto Print, Single Head Auto Print, single head auto printing press, automatic garment printing press, single head automatic printing machine, auto screen printing machine India"
  },
  32: {
    title: "Electric Flash Curer Trolley CTC for Garments | Cheran’s",
    description:
      "Cheran’s Electric Flash Curer Trolley (CTC) is a portable flash curing machine for garment printing. Efficient movable trolley flash dryer solution.",
    keywords:
      "electric flash curing machine, Cheran electric flash curer trolley, trolley curer CTC, trolley flash curing machine, movable flash dryer for garment printing, portable flash curing unit"
  },
  33: {
    title: "Digital Heat Transfer Fusing Machine | Cheran’s Textile Press",
    description:
      "Cheran’s Digital Heat Transfer Fusing Machine provides precise textile heat transfer for garments. Efficient digital fusing press for high-volume production.",
    keywords:
      "Cheran digital heat transfer fusing machine, Digital Heat Transfer Fusing Machine, textile heat transfer machine."
  },

};

export default productSeo;
